export enum UserRole {
  Operator = 'Operator',
  Supervisor = 'Supervisor',
  Admin = 'Admin',
  RoTec = 'RoTec',
}

export enum UserGridKeys {
  Id = 'id',
  Email = 'email',
  GivenName = 'givenName',
  Surname = 'surname',
  Role = 'role',
  Actions = 'actions',
}
